type InlineEditingActivePayload = {
  sectionId?: string;
  blockId?: string;
  attribute: string;
};

type UpdateContentPayload = InlineEditingActivePayload & { content: string };

const SET_CURRENT_INLINE_EDITING_SECTION = 'KJB/SET_CURRENT_INLINE_EDITING_SECTION';
const UNSET_CURRENT_INLINE_EDITING_SECTION = 'KJB/UNSET_CURRENT_INLINE_EDITING_SECTION';
const UPDATE_CONTENT_INLINE = 'KJB/UPDATE_CONTENT_INLINE';
const EDIT_STYLE_GUIDE = 'KJB/EDIT_STYLE_GUIDE';
const EDIT_SETTING = 'editSetting';
const UNDO_EDITING = 'KJB/BUILDER_UNDO';
const REDO_EDITING = 'KJB/BUILDER_REDO';

export const setInlineEditingActive = (payload: InlineEditingActivePayload) => ({
  type: SET_CURRENT_INLINE_EDITING_SECTION,
  payload,
});

export const unsetInlineEditingActive = (payload: InlineEditingActivePayload) => ({
  type: UNSET_CURRENT_INLINE_EDITING_SECTION,
  payload,
});

export const updateContent = (payload: UpdateContentPayload) => ({
  type: UPDATE_CONTENT_INLINE,
  payload,
});

export const editSetting = (setting: string) => ({
  type: EDIT_SETTING,
  setting,
});

export const editStyleGuide = () => ({
  type: EDIT_STYLE_GUIDE,
});

export const undoEditing = () => ({
  type: UNDO_EDITING,
});

export const redoEditing = () => ({
  type: REDO_EDITING,
});
